import React, {useCallback} from "react";
import styled from "@emotion/styled";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {PlayerPositionEnum} from "modules/enums";
import {EmptyPlayerCard, PlayerMark, PlayerPosition, PlayerTop} from "components/Common";
import {setIsOpenPlayerPool, setPlayerPoolFilterPosition} from "modules/actions";
import {useIsMobile, toLowerCase} from "modules/utils";
import {ReactComponent as AddIcon} from "assets/images/icons/add.svg";
import emptyPlayer from "assets/images/emptyPlayer.svg";

const ActionIcon = styled.div`
	z-index: 5;
	margin-top: 8px;
`;

interface IProps {
	position: PlayerPositionEnum;
}

export const PlayerEmpty: React.FC<IProps> = ({position}) => {
	const dispatch = useDispatch();
	const {isMobile} = useIsMobile("(max-width: 1000px)");
	const {t} = useTranslation();

	const handleClick = useCallback(() => {
		dispatch(setPlayerPoolFilterPosition(position));

		if (isMobile) {
			dispatch(setIsOpenPlayerPool(true));
		}
	}, [dispatch, position, isMobile]);

	return (
		<EmptyPlayerCard onClick={handleClick}>
			<PlayerTop>
				<ActionIcon>
					<AddIcon />
				</ActionIcon>
				<PlayerMark src={emptyPlayer} alt="Empty player" className="empty" />
			</PlayerTop>

			<PlayerPosition>
				<span>{t(toLowerCase(`game.position.${position}`))}</span>
			</PlayerPosition>
		</EmptyPlayerCard>
	);
};
